
import Carousel from '~/components/carousel/carousel'
import ProductCard from '~/components/product-card/ProductCard'
export default {
  components: {
    Carousel,
    ProductCard,
  },
  props: {
    wording: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      products: [],
    }
  },
  computed: {
    collectionHandle() {
      return this.product.metafield.breadcrumb[0]
    },
  },
  mounted() {
    if (this.collectionHandle && this.wording.carousel_category_isActive)
      this.fetchCollectionFromSearchSpring(this.collectionHandle)
  },
  methods: {
    async fetchCollectionFromSearchSpring() {
      try {
        const url = `https://api.searchspring.net/api/search/search.json?siteId=${this.getSiteId()}&resultsFormat=native&format=json&bgfilter.collection_handle=${
          this.collectionHandle
        }&resultsPerPage=10&page=1`
        const { data } = await this.$axios.get(url)
        if (data && data.results && data.results.length > 0)
          this.parseResults(data)
      } catch (e) {
        this.$sentryException(e, {
          source: 'PDP - Carrousel Category',
          level: 'warning',
          extra: `Error : ${e}`,
        })
      }
    },
    getSiteId() {
      switch (this.$i18n.locale) {
        case 'en-ca':
          return this.$config.SEARCHSPRING_SITE_IDS.EN_CA
        case 'fr-ca':
          return this.$config.SEARCHSPRING_SITE_IDS.FR_CA
        case 'en-eu':
          return this.$config.SEARCHSPRING_SITE_IDS.EN_EU
        case 'fr-eu':
          return this.$config.SEARCHSPRING_SITE_IDS.FR_EU
        default:
          return this.$config.SEARCHSPRING_SITE_IDS.EN_US
      }
    },
    async parseResults(data) {
      this.products = await this.$searchspring.parseProducts.parse(data)
        ?.resultProducts
    },
  },
}
